<template>
  <div>
    <div ref="journalJson">
      <template>
        <div v-for="(value, key, index) in json" :key="index" 
          class="parent-log-block"
          :class="{
            'log-block': depth === 3,
            'nested': nested || depth === 0,
            'nested-indent': nested,
            'new-line-before': Array.isArray(parent) && index === 0,
            'new-line-after': Array.isArray(parent) && index === Object.keys(json).length - 1,
          }"
        >
          <span v-if="Array.isArray(value) && value.every(item => typeof item === 'string')">
            <span v-for="item in value" :key="item">
              <div style="display: block;">
                <span class="font-weight-bold">{{ formatKey(key) }}:</span>
                {{ formatValue(item) }}
              </div>
            </span>
          </span>
          <span v-else>
            <span class="font-weight-bold">{{ formatKey(key) }}:</span>
            <span v-if="isObject(value)">
              <JournalJson :json="value" :nested="true" :parent="json" :depth="depth + 1" />
            </span>
            <span v-else-if="Array.isArray(value)">
              <template>
                <div v-for="(item, index) in value" :key="index">
                  <JournalJson :json="item" :nested="true" :parent="value" :depth="depth + 1"/>
                </div>
              </template>
            </span>
            <span v-else class="font-weight-regular left-margin">
              {{ formatValue(value) }}
            </span>
          </span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JournalJson',
  props: {
    json: {
      type: Object,
      required: true,
    },
    nested: {
      type: Boolean,
      default: false,
    },
    parent: {
      type: [Object, Array],
      default: null,
    },
    depth: {
      type: Number,
      default: 0,
    }
  },
  computed: {
  },
  methods: {
    isObject(value) {
      return value && typeof value === 'object' && !Array.isArray(value);
    },
    formatKey(key) {
      return key
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/utrein:/g, '')
      .replace(/utreko:/g, '')
      .trim()
    },
    formatValue(value) {
      if (typeof value === 'string') {
        return value.replace(/\r?\n|\r/g, " ");
      } else {
        return value;
      }
    },
    getFormattedText(obj, level = 0) {
      let text = '';
      const indent = ' '.repeat(level * 4);
      const isObject = (value) =>
        value && typeof value === 'object' && !Array.isArray(value);

      for (const key in obj) {
        const value = obj[key];
        const formatKeyValue = this.formatKey(key);
        if (Array.isArray(value) && value.every(item => typeof item === 'string')) {
          //<span v-for="item in value" :key="item">
          for (const item of value) {
            text += `${indent}${formatKeyValue}: `;
            text += this.formatValue(item) + '\n';
          }
        } else {
          text += `${indent}${formatKeyValue}: `;
          if (isObject(value)) {
            text += '\n' + this.getFormattedText(value, level + 1);
          } else if (Array.isArray(value)) {
            text += '\n';
            for (const item of value) {
              text += this.getFormattedText(item, level + 1);
            }
          } else {
            text += this.formatValue(value) + '\n';
          }
        }
      }

      return text;
    },
  },
};
</script>

<style scoped>
.nested {
  position: relative;
}

.nested-indent {
  margin-left: 2rem;
}

.nested:before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  width: 1px;
  background-color: #ccc;
  opacity: 0.5;
}

.new-line-before {
  margin-top: 0.5rem;
}

.new-line-after {
  margin-bottom: 0.5rem;
}

.divider {
  height: 1px;
  background-color: #ccc;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.left-margin {
  margin-left: 0.5rem;
}

.log-block {
  background-color:#f0f0f0;
}

.parent-log-block .log-block:last-child {
  margin-bottom: 1.5rem;
}

</style>
